<template>
    <div>
<!--        <h1 class="mb-8 font-bold text-3xl">-->
<!--            <Link class="text-indigo-400 hover:text-indigo-600" :href="this.route('tickets')">{{ __('Tickets') }}</Link>-->
<!--            <span class="text-indigo-400 font-medium">/</span> {{ __('Create') }}-->
<!--        </h1>-->
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="store">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">


                    <select-input-filter
                        placeholder="Begin met typen" :onInput="doFilter" :items="customersData"
                        v-model="form.user_id" :error="form.errors.user_id"
                        class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Customer')"
                        :key="form.customer_id"
                        :selectedValue="form.customer_id" 
                        @update:modelValue="value => form.customer_id = value">
                    </select-input-filter>


                    <select-input v-if="user_access.ticket.update" v-model="form.priority_id" :error="form.errors.priority_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Priority')">
                        <option :value="null" />
                        <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>
                    <select-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" v-model="form.type_id" :error="form.errors.type_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Ticket Type')">
                        <option :value="null" />
                        <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>
                    


                    <select-input
                        v-if="!(hidden_fields && hidden_fields.includes('department'))"
                        @change="getCategories()"
                        v-model="form.department_id"
                        :error="form.errors.department_id"
                        :required="true"
                        class="pr-6 pb-5 md:col-span-6 lg:w-1/3"
                        :label="__('Department')"
                    >
                    <option :value="null">{{ __('Select a department') }}</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
                    </select-input>

                    <select-input ref="category" v-if="!(hidden_fields && hidden_fields.includes('category')) && form.department_id" @change="getSubCategories()" v-model="form.category_id" :error="form.errors.category_id" class=" pb-5 pr-6 md:col-span-6 lg:w-1/3" :label="__('Category')">
                        <option :value="null">{{ __('Select a category') }}</option>
                        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select-input>

                    <select-input-filter placeholder="Begin met typen" :onInput="doFilterUsersExceptCustomer" :items="usersExceptCustomers"
                                         v-if="auth.user.role.slug !== 'customer' && user_access.ticket.update && !(hidden_fields && hidden_fields.includes('assigned_to'))"
                                         v-model="form.assigned_to" :error="form.errors.assigned_to"
                                         class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Assigned to')">
                    </select-input-filter>

                    <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
                        <label class="form-label">Deadline</label>
                        <Datepicker
                            v-model="form.deadline"
                            :input-class="'form-input'"
                            class="bg-white w-full rounded-md border border-gray-300 hover:border-indigo-500 hover:shadow focus:shadow-md transition duration-150 ease-in-out"
                            placeholder="Select a date"
                        ></Datepicker>
                    </div>

                    <select-input v-if="user_access.ticket.update" v-model="form.status_id" :error="form.errors.status_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Status')">
                        <option :value="null" />
                        <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
                    </select-input>

                    <!-- <input type="date" v-model="form.deadline" class="form-input pr-6 pb-8 w-full lg:w-full" /> -->

                    <text-input v-model="form.subject" :error="form.errors.subject" class="pr-6 pb-8 w-full lg:w-full" :label="__('Subject')" :is_required="true" />
                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label" >Request Details:</label>
                        <ckeditor id="ticketDetails" :editor="editor" v-model="form.details" :config="editorConfig"></ckeditor>
                    </div>
                    <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden" multiple="multiple" @change="fileInputChange" />
                    <div class="pr-6 pb-8 w-full lg:w-full flex-col">
                        <button type="button" class="btn flex justify-center items-center" @click="fileBrowse">
                            <icon name="file" class="flex-shrink-0 h-8 fill-gray-400 pr-1" /> <h4>{{ __('Attach files') }}</h4>
                        </button>
                        <div v-if="form.files.length" class="flex items-center justify-between pr-6 pt-8 w-full lg:w-1/2" v-for="(file, fi) in form.files" :key="fi">
                            <div class="flex-1 pr-1">
                                <img
                                    v-if="file.type?.startsWith('image/')"
                                    :src="getFilePreview(file)"
                                    class="max-h-40 my-2 rounded cursor-pointer"
                                    alt="Attachment Preview"
                                    @click="openLightbox(getFilePreview(file))"
                                />
                                <div>
                                    {{ file.name }} <span class="text-gray-500 text-xs">({{ getFileSize(file.size) }})</span>
                                </div>
                            </div>
                            <button type="button" class="btn flex justify-center items-center" @click="fileRemove(file, fi)">
                                {{ __('Remove') }}</button>
                        </div>
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}
                        {{ __('Ticket') }}</loading-button>
                </div>
            </form>
        </div>
    </div>

    <div
        v-if="lightboxVisible"
        class="fixed inset-0 flex justify-center items-center z-50"
    >
        <div
            class="absolute inset-0 bg-black bg-opacity-75"
            @click="closeLightbox"
        ></div>
        <img
            :src="lightboxImage"
            class="relative max-w-full max-h-full"
            alt="Full Screen Image"
            @click.stop
        />
    </div>
</template>

<style scoped>
    .fixed {
        position: fixed;
    }
    .inset-0 {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
    .z-50 {
        z-index: 50;
    }
    .bg-black {
        background-color: black;
    }
    .bg-opacity-75 {
        opacity: 0.75;
    }
    .flex {
        display: flex;
    }
    .justify-center {
        justify-content: center;
    }
    .items-center {
        align-items: center;
    }
    .cursor-pointer {
        cursor: pointer;
    }
</style>


<script>
import { Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';
import CKEditor from '@ckeditor/ckeditor5-vue';
import axios from 'axios'
import Datepicker from 'vue3-datepicker';


export default {
    metaInfo: { title: 'Create Ticket' },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
        ckeditor: CKEditor.component,
        Datepicker,
    },
    layout: Layout,
    props: {
        customers: Array,
        usersExceptCustomers: Array,
        priorities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        all_categories: Array,
        auth: Object,
        hidden_fields: Object,
        preselected_customer: String,
        request_details: String,
        subject: String,
    },
    remember: false,
    data() {
        return {
            lightboxVisible: false,
            lightboxImage: '',
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            categories: [],
            sub_categories: [],
            customersData: [...this.customers], //copy customers so not read only anymore
            form: this.$inertia.form({
                user_id: null,
                priority_id: 1,
                status_id: 1,
                department_id: null,
                category_id: null,
                sub_category_id: null,
                assigned_to: null,
                type_id: null,
                subject: this.subject ?? null,
                details: this.request_details ?? null,
                files: [],
                deadline: null,
            }),
        }
    },
    created() {
        this.setDefaultValue(this.statuses, 'status_id', 'Nieuw')
        this.setDefaultValue(this.priorities, 'priority_id', 'Generally')
    },
    methods: {
        openLightbox(imageSrc) {
            this.lightboxImage = imageSrc;
            this.lightboxVisible = true;
        },
        closeLightbox() {
            this.lightboxVisible = false;
            this.lightboxImage = '';
        },
        getFilePreview(file) {
            // Generate a preview URL for newly uploaded files
            if (file instanceof File) {
                return URL.createObjectURL(file);
            }
            return ''; // Fallback for non-file objects
        },
        getCategories(){
            this.categories = this.all_categories.filter(cat=>cat.department_id === this.form.department_id)
            this.form.category_id = null;
            this.$refs.category.selected = null;
        },
        getSubCategories(){
            this.sub_categories = this.all_categories.filter(cat=>cat.parent_id === this.form.category_id)
            this.form.sub_category_id = null;
            this.$refs.sub_category.selected = null;
        },
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        doFilter(e){
            axios.get(this.route('filter.customers', {search: e.target.value})).then((res)=>{
                this.customersData.splice(0, this.customersData.length, ...res.data);
            })
        },
        doFilterUsersExceptCustomer(e){
            axios.get(this.route('filter.users_except_customer', {search: e.target.value})).then((res)=>{
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data);
            })
        },
        setDefaultValue(arr, key, value){
            const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
            if(find){
                this.form[key] = find['id']
            }
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        store() {
            // this.form.user_id = this.auth.user.id;
            console.log(this.form);
            this.form.post(this.route('tickets.store'))
        },
    },
    created() {

        if (this.preselected_customer) {
            axios.get(this.route('filter.customerbyid', {id: this.preselected_customer})).then((res)=>{

                this.form.user_id = Number(this.preselected_customer);

                this.customersData.splice(0, this.customersData.length, ...res.data);

            });
        }
    }
}
</script>
